var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlarm = function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "alarm_svg__a",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("mask", {
    id: "alarm_svg__b",
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#alarm_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-26 -26)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#alarm_svg__a",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    mask: "url(#alarm_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M53 34.378c5.176 1.332 9 6.03 9 11.622v10l4 5.99V64H34v-2.01L38 56V46c0-5.592 3.824-10.29 9-11.622V33c0-1.657 1.347-3 3-3 1.657 0 3 1.347 3 3zM54 66c0 2.21-1.79 4-4 4s-4-1.79-4-4z"
  }))));
};
export default SvgAlarm;